import { render } from "./vip-info.vue?vue&type=template&id=faae2412&scoped=true&ts=true"
import script from "./vip-info.vue?vue&type=script&lang=tsx"
export * from "./vip-info.vue?vue&type=script&lang=tsx"

import "./vip-info.vue?vue&type=style&index=0&id=faae2412&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faae2412"]])

export default __exports__